"use client";
import classNames from "classnames";
import { Game } from "../game";

import { onScreenScroll } from "@/events";
import { useIsMobile } from "@/store/device";
import { useEffect, useState } from "react";
import { IMainPageGames } from "./main-page-games.types";

export const MainPageGames: IMainPageGames = ({ games }) => {
  const shownGames = games.slice(0, 3);

  const [activeItem, setActiveItem] = useState(0);

  const isMobile = useIsMobile();

  const setItem = (id: number) => () => {
    setActiveItem(id);
  };

  const onMouseLeave = () => {
    setActiveItem(0);
  };

  useEffect(() => {
    window.addEventListener("scroll", onScreenScroll);

    return () => window.removeEventListener("scroll", onScreenScroll);
  }, []);

  return (
    <section className="main-page-games w-full h-auto flex flex-col lg:flex-row lg:h-[calc(100vw/3)] sm:h-auto border-t-[4px] border-t-base-01">
      {shownGames.map((game, id) => (
        <div
          key={id}
          onMouseEnter={isMobile ? undefined : setItem(id)}
          onMouseLeave={isMobile ? undefined : onMouseLeave}
          onClick={isMobile ? setItem(id) : undefined}
          className={classNames(
            "main-mage-game",
            "flex h-full lg:w-[28%] hover:grow-2 ease-in duration-300 md:hover:opacity-100",
            {
              "lg:w-[28%]": activeItem !== id,
              "lg:w-[44%]": activeItem === id,
              "md:opacity-50": activeItem !== id,
            }
          )}
        >
          <Game
            {...game}
            smallIcons
            className="h-full"
          />
        </div>
      ))}
    </section>
  );
};
